import posthog from './posthog';

type Empty = Record<string, never>;

export type Events = {
  // The root Sentry error boundary or the router's errorElement rendered the
  // crash page in place of the app.
  error_page_shown: Empty;
  // A token joined the watchlist from the list page's Add button.
  watchlist_token_added: { symbol: string };
};

type EventsWithEmptyProps = {
  [K in keyof Events]: Events[K] extends Empty ? K : never;
}[keyof Events];

type EventsWithProps = Exclude<keyof Events, EventsWithEmptyProps>;

export function track(event: EventsWithEmptyProps): void;
export function track<E extends EventsWithProps>(
  event: E,
  props: Events[E],
): void;
export function track<E extends keyof Events>(
  event: E,
  props?: Events[E],
): void {
  posthog.capture(event, props);
}
